import { useTranslation } from '../i18n';

/**
 *  Hook to get the contextualized locale for the schedule activity plugin.
 */
export const useScheduleActivityLocale = (): ReturnType<
  typeof useTranslation
> => useTranslation();
